const storeDictES = {
  store: "Tienda",
  storeSettings: "Configuración",
  storeOrders: "Pedidos",
  storeSchedules: "Citas",
  storeSchedulesSubtitle: "Gestiona las citas sincronizadas con Google Calendar",
  storeTotalOrders: "Total de pedidos",
  storePendingOrders: "Pedidos pendientes",
  orderDetails: "Detalles del pedido",
  storeOrderDetails: "Detalles del pedido",
  storeProducts: "Productos",
  myStore: "Mi tienda",
  storePanelTitle: "Panel de tienda",
  storePanelSubtitle: "Gestiona las operaciones de tu tienda.",
  storeOperations: "Operaciones",
  storeRegisteredArticles: "Artículos registrados",
  storeRevenue: "Ventas",
  storePendingOperations: "Operaciones pendientes",
  sinceStart: "Desde el inicio",
  awaitingProcessing: "En espera de procesamiento",
  latestOrders: "Últimos pedidos",
  allOrders: "Todos los pedidos",
  newProduct: "Nuevo producto",
  settingsTabGeneral: "General",
  settingsTabLocationContact: "Ubicación y contacto",
  settingsTabIntegrations: "Integraciones",
  integrationsDisabled: "Desactivado",
  backToPage: "Volver a la página",
  newProductOverlayTitle: "Nuevo producto",
  stepGeneralInfo: "Información general",
  stepGeneralInfoSubtitle: "Aumenta las ventas con información detallada del producto",
  stepPriceDetails: "Detalles de precio",
  stepPriceDetailsTitle: "Agrega detalles del producto",
  stepPriceDetailsSubtitle: "Aumenta las ventas con información detallada del producto",
  stepProductImage: "Imagen del producto",
  stepStockAvailability: "Stock y disponibilidad",
  stepSummary: "Resumen",
  next: "Siguiente",
  previous: "Anterior",
  submitProduct: "Registrar producto",
  cancel: "Cancelar",
  filterByOrderId: "ID del pedido",
  filterByDateRange: "Rango de fechas",
  filterByStatus: "Estado",
  search: "Buscar",
  customer: "Cliente",
  product: "Producto",
  service: "Servicio",
  downloadable: "Descargable",
  integrationsComingSoon: "Próximamente",
  website: "Sitio web",
  save: "Guardar",
  logo: "Logo",
  storeSettingsLogoHelp: "Imagen mostrada como logo de tu tienda. Recomendado: relación 4:1.",
  storeSettingsTitleHelp: "Nombre mostrado de tu tienda.",
  storeSettingsDescriptionHelp: "Breve descripción de tu tienda.",
  storeSettingsWebsiteHelp: "URL del sitio web de tu tienda o empresa.",
  storeSettingsSocialHelp:
    "Solo el nombre de usuario o perfil (ej.: mipagina para instagram.com/mipagina).",
  storeSettingsMinOrderHelp: "Valor mínimo del pedido para aplicar la regla de envío seleccionada.",
  storeSettingsFreightValueHelp:
    "Valor o porcentaje de descuento aplicado cuando se cumple la regla.",
  storeSettingsClickToUpload: "Haz clic para subir",
  storeSettingsOrDragDrop: "o arrastra y suelta",
  storeSettingsLogoFormats: "PNG, JPG o WebP. Máx. 5 MB.",
  storeSettingsCategoriesHelp: "Categorías a las que pertenece tu tienda.",
  storeSettingsAtecoHelp: "Busca y añade códigos ATECO de la actividad de tu tienda.",
  storeSettingsStoreLinkHelp: "Solo letras minúsculas y números, hasta 20 caracteres. Déjalo en blanco para no usar un enlace personalizado.",
  storeSettingsStoreLinkPlaceholder: "mitienda",
  storeSettingsCopyLink: "Copiar enlace",
  storeSettingsLinkCopied: "¡Enlace copiado!",
  storeSettingsCopyLinkDisabled: "Guarda el enlace personalizado para poder copiarlo.",
  free: "Gratis",
  productInfo: "Información del producto",
  editProduct: "Editar producto",
  storeEditTabGeneral: "Detalles generales",
  storeEditTabImages: "Imágenes del producto",
  storeEditTabStock: "Estado del stock",
  storeEditImagesHint: "Use la pestaña Detalles generales para gestionar las imágenes.",
  storeEditStockHint: "Use la pestaña Detalles generales para gestionar stock y publicación.",
  noProducts: "Ningún producto registrado.",
  errorLoadingProduct: "Error al cargar el producto.",
  orderDetailsSubtitle: "Puedes supervisar y gestionar los detalles del pedido.",
  orderDetailsStep1Send: "Enviar pedido",
  orderDetailsStep2Delivered: "Pedido entregue",
  orderDetailsStep3Payment: "Recibir pago",
  orderDetailsStep4Completed: "Compra completada",
  orderDetailsAlertToProcess:
    "A procesar. ¡Has recibido un nuevo pedido! Comprueba la disponibilidad de los productos e inicia la preparación.",
  orderDetailsTransactionId: "ID de transacción",
  orderDetailsSummaryPurchase: "Resumen de la compra",
  orderDetailsSubtotal: "Subtotal",
  orderDetailsCoupon: "Cupón",
  orderDetailsVat: "IVA",
  orderDetailsShippingCosts: "Gastos de envío",
  orderDetailsTotal: "Total",
  orderDetailsTotalReceived: "Total recibido",
  orderDetailsCashback: "Cashback",
  orderDetailsPaymentMethod: "Método de pago",
  orderDetailsCreditCard: "Tarjeta de crédito",
  orderDetailsExtracredit: "Extracredit",
  orderDetailsBuyer: "Comprador",
  orderDetailsContact: "Contacto",
  orderDetailsPhone: "Teléfono",
  orderDetailsEmail: "Correo electrónico",
  orderDetailsShippingData: "Datos de envío",
  orderDetailsStatusToProcess: "A procesar",
  orderDetailsStatusShipped: "Enviado",
  orderDetailsStatusDelivered: "Entregado",
  orderDetailsCancelOrder: "Cancelar pedido",
  orderDetailsSendProduct: "Enviar producto",
  orderDetailsOrderConfirmed: "Pedido confirmado",
  orderDetailsPaymentApproved: "El pago fue aprobado.",
  orderDetailsProductInTransit: "El producto está en tránsito.",
  orderDetailsProductDelivered: "El producto fue entregado.",
  orderDetailsLoading: "Cargando...",
  shippingIncluded: "Envío incluido",
  notifyAllUsers: "Notificar a todos los usuarios",
  notifyMyEconomicCircle: "Notificar a mi círculo económico",
  notifications: "Notificaciones",
  fileForDownload: "Archivo para descarga",
  sampleFileOptional: "Muestra / vista previa (opcional)",
  downloadFileType: "Tipo de archivo",
  downloadTypeAudio: "Audio",
  downloadTypeVideo: "Video",
  downloadTypeImage: "Imagen",
  downloadTypeDocument: "Documento",
  publishProductNow: "Publicar producto ya",
  uploadZoneInstruction: "Elija un archivo o arrástrelo aquí.",
  uploadZoneFormatsImages: "Formatos JPEG, PNG y MP4, hasta 50 MB.",
  uploadZoneFormatsFile: "Todos los formatos, hasta 100 MB.",
  browseFiles: "Examinar archivos",
  primaryImage: "Principal",
  activate: "Activar",
  confirmCode: "Confirmar código",
  whatsappDisconnected: "WhatsApp desconectado",
  whatsappHasBeenDisconnected: "WhatsApp ha sido desconectado exitosamente.",
  errorDisconnectingWhatsApp: "Error al desconectar WhatsApp. Por favor, inténtalo de nuevo.",
  activated: "Activado",
  deactivated: "Desactivado",
  removeIntegration: "Eliminar integración",
  confirmRemoveIntegration:
    "¿Estás seguro de que deseas eliminar esta integración? Esta acción no se puede deshacer.",
  confirmation: "Confirmación",
  yes: "Sí",
  no: "No",
  googleCalendar: "Google Calendar",
  googleCalendarDescription: "Sincroniza tus eventos y citas con Google Calendar",
  apiKey: "Clave de API",
  clientId: "ID del Cliente",
  clientSecret: "Secreto del Cliente",
  configure: "Configurar",
  integrationsDescription:
    "Conecta tu tienda con herramientas externas para optimizar tu flujo de trabajo",
  whatsappIntegrationDescription:
    "Conecta tu tienda a WhatsApp para atención directa a los clientes",
  phoneNumber: "Número de teléfono",
  phoneNumber1: "Número de teléfono",
  enterYourPhoneNumber: "Ingresa tu número de teléfono",
  attention: "Atención",
  pleaseProvidePhoneNumber: "Por favor, proporciona un número de teléfono",
  codeSent: "Código enviado",
  confirmationCodeSentToWhatsApp: "Código de confirmación enviado a WhatsApp",
  error: "Error",
  errorConnectingToServer: "Error al conectar al servidor",
  pleaseProvideConfirmationCode: "Por favor, proporciona el código de confirmación",
  success: "Éxito",
  whatsappConfiguredSuccessfully: "WhatsApp configurado exitosamente",
  invalidConfirmationCode: "Código de confirmación inválido",
  configurationSavedSuccessfully: "Configuración guardada exitosamente",
  goBackAndResendCode: "Volver y reenviar código",
  confirmationCode: "Código de confirmación",
  enterReceivedCode: "Ingresa el código recibido",
  integrationData: "Datos de la integración",
  redirectedToGoogleAuth:
    "Redirigido a la autenticación de Google. Completa el proceso en la nueva pestaña.",
  errorGettingAuthUrl: "Error al obtener la URL de autenticación",
  googleCalendarDisconnected: "Google Calendar desconectado",
  googleCalendarHasBeenDisconnected: "Google Calendar ha sido desconectado exitosamente.",
  errorDisconnectingGoogleCalendar:
    "Error al desconectar Google Calendar. Por favor, inténtalo de nuevo.",
  noSchedulesYet: "Aún no hay citas",
  scheduleConnectGoogleCalendar:
    "Conecta Google Calendar en la pestaña de integraciones para sincronizar tus citas",
  confirmed: "Confirmado",
  pending: "Pendiente",
  manageOrders: "Gestiona tus pedidos",
  manageProducts: "Gestiona tus productos",
  manageSchedules: "Gestiona tus citas",
  viewSchedules: "Ver citas",
  scheduleSetupTitle: "Configuración inicial requerida",
  scheduleSetupDescription: "Para usar el sistema de citas, sigue los pasos a continuación:",
  scheduleStep1Title: "Conectar Google Calendar",
  scheduleStep1Description: "Conecta tu cuenta de Google Calendar para sincronizar citas",
  scheduleStep1Connected: "Google Calendar conectado con éxito",
  scheduleStep2Title: "Configurar preferencias de horario",
  scheduleStep2Description:
    "Define los días y horarios en que los clientes pueden reservar tus servicios",
  scheduleStep2Configured: "Preferencias de horario configuradas",
  connect: "Conectar",
  integrationComplete: "¡Integración completa!",
  yourAccountIsNowConnected: "Tu cuenta ahora está conectada.",
  whatsappBotReady: "El bot de WhatsApp está listo para leer tu agenda.",
  integrationIncomplete: "Integración incompleta",
  youNeedToCompleteTheFollowingSteps: "Necesitas completar los siguientes pasos.",
  standardAppointmentLength: "Duración estándar de la cita",
  scheduleBufferLabel: "Tiempo entre citas (min)",
  scheduleBufferHelp: "Descanso entre atenciones",
  scheduleAppointmentLengthHelp: "Duración predeterminada de la cita",
  scheduleWorkStartLabel: "Inicio del horario laboral",
  scheduleWorkEndLabel: "Fin del horario laboral",
  scheduleSelectDays: "Seleccione los días de atención",
  scheduleClientInstructionsLabel: "Instrucciones para el cliente",
  scheduleClientInstructionsPlaceholder: "Ej.: llegue al lugar con 15 minutos de anticipación.",
  scheduleClientInstructionsHelp:
    "Estas instrucciones se enviarán al cliente al confirmar la cita.",
  monday: "Lunes",
  tuesday: "Martes",
  wednesday: "Miércoles",
  thursday: "Jueves",
  friday: "Viernes",
  saturday: "Sábado",
  sunday: "Domingo",
  openYourGoogleCalendar: "Abrir tu Google Calendar",
  availability: "Disponibilidad",
  scheduleStep3Title: "Citas y reservas",
  scheduleStep3Description: "Gestiona citas y solicitudes de soporte directamente desde tu agenda.",
  configureYourAvailability: "Configura tu disponibilidad",
  defineDaysAndTimes:
    "Define los días y horarios en que los clientes pueden reservar tus servicios",
  removeWhatsAppIntegration: "¿Eliminar la integración con WhatsApp?",
  removeWhatsAppIntegrationDescription:
    "El número de teléfono será eliminado de nuestros sistemas y el botón de contacto ya no será visible para los clientes de su tienda. Puede reactivar el servicio en cualquier momento.",
  removeGoogleCalendarIntegration: "¿Eliminar la integración con Google Calendar?",
  removeGoogleCalendarIntegrationDescription:
    "La conexión con Google Calendar se eliminará y sus citas ya no se sincronizarán. Puede reactivar el servicio en cualquier momento.",
  remove: "Eliminar",
  physicalStore: "Tienda Física",
  physicalStoreConventionTitle: "Convenio de Tienda Física",
  physicalStoreConventionSubtitle:
    "Lee y firma el convenio para activar tu tienda física y empezar a recibir pagos.",
  physicalStoreConventionAlreadySigned: "Convenio ya firmado",
  physicalStoreConventionAlreadySignedDesc: "Ya has firmado el convenio de tienda física. No se requiere ninguna acción adicional.",
  physicalStoreConventionAccept: "He leído y acepto los términos del convenio",
  physicalStoreConventionConfirm: "Confirmar y firmar",
  physicalStoreConventionSignedSuccess: "¡Convenio firmado con éxito!",
  physicalStoreConventionSignedError: "Error al firmar el convenio. Inténtalo de nuevo.",
  physicalStoreConventionLoading: "Cargando convenio...",
  physicalStoreConventionCommercialName: "Nombre comercial",
  physicalStoreConventionCompanyName: "Nombre de la empresa",
  physicalStoreConventionAddress: "Dirección",
  physicalStoreConventionNumber: "Número",
  physicalStoreConventionCity: "Ciudad",
  physicalStoreConventionPostalCode: "Código postal",
  physicalStoreConventionProvince: "Provincia / Estado",
  physicalStoreConventionPhone: "Teléfono",
  physicalStoreConventionProofPhoto: "Foto del establecimiento",
  physicalStoreConventionProofPhotoPlaceholder: "Haga clic para seleccionar una imagen",
  physicalStoreConventionUploading: "Enviando...",
  physicalStoreConventionPendingTitle: "Comprobante en revisión",
  physicalStoreConventionPendingMessage: "Su comprobante ha sido enviado y está pendiente de revisión. Pronto podrá usar la tienda física.",
  physicalStoreConventionRejectedTitle: "Comprobante rechazado",
  physicalStoreConventionApprovedTitle: "Tienda física aprobada",
  physicalStoreConventionApprovedMessage: "Su tienda física ha sido aprobada. Ya puede utilizar todas las funciones de pago físico.",
  physicalStoreConventionLegalRepresentative: "Nombre del representante legal",
  physicalStoreConventionTaxId: "NIF/CIF",
  physicalStoreConventionMerchantCategory: "Categoría del establecimiento",
  physicalStoreConventionViewDoc: "Ver términos del convenio",
  physicalStoreNewPayment: "Nuevo pago",
  physicalStoreNewPaymentDesc: "Crea un nuevo cobro con QR Code",
  physicalStorePaymentsList: "Historial de pagos",
  physicalStorePaymentsListDesc: "Ver todos los pagos recibidos",
  physicalStoreCameraPayment: "Pagar con cámara",
  physicalStoreCameraPaymentDesc: "Escanea el QR Code para cobrar",
  physicalStoreVerificationTitle: "Verificación de la tienda física",
  physicalStoreVerificationSubtitle: "Envía un comprobante para habilitar cobros",
  physicalStoreVerificationPendingSubtitle: "Tu comprobante está en revisión",
  physicalStoreVerificationPendingMessage:
    "Tu comprobante fue enviado y está a la espera de revisión. Pronto podrás crear cobros.",
  physicalStoreVerificationRejected: "Comprobante rechazado",
  physicalStoreVerificationAddressPlaceholder: "Calle / Av.",
  physicalStoreVerificationNumberPlaceholder: "N.º",
  physicalStoreVerificationPostalCodePlaceholder: "00000-000",
  physicalStoreVerificationStatePlaceholder: "Estado",
  addProduct: "Añadir producto",
  searchProductByName: "Buscar por nombre del producto",
  productsViewGrid: "Vista en cuadrícula",
  productsViewList: "Vista en lista",
  productListValue: "Valor",
  productListRegistration: "Registro",
  sortBy: "Ordenar",
  sortMostRecent: "Más reciente",
  sortOldest: "Más antiguo",
  sortHighestValue: "Mayor valor",
  unpublishProduct: "Despublicar producto",
  publishProduct: "Publicar producto",
  notifyUsers: "Notificar usuarios",
  notifyEconomicCircle: "Notificar círculo económico",
  productTypeModalTitle: "¿Qué tipo de producto o servicio vas a registrar?",
  productTypePhysical: "Producto físico",
  productTypePhysicalDesc: "Productos que se entregarán a los clientes.",
  productTypeService: "Servicio",
  productTypeServiceDesc: "Servicio que prestas a los clientes.",
  productTypeDigital: "Producto digital",
  productTypeDigitalDesc: "Los clientes podrán descargar tu producto.",
  addProductDetails: "Añadir detalles del producto",
  addProductDetailsSubtitle: "Describe los detalles de tu producto para su visualización.",
  addServiceDetails: "Añadir detalles del servicio",
  addServiceDetailsSubtitle: "Describe los detalles de tu servicio para su visualización.",
  productName: "Nombre del producto",
  productNamePlaceholder: "Introduce el nombre del producto",
  serviceNamePlaceholder: "Introduce el nombre del servicio",
  productState: "Estado del producto",
  productStateNew: "Nuevo",
  productStateUsed: "Usado",
  withVariation: "¿Con variación?",
  withVariationHelp: "Ideal para artículos con distintos tamaños o colores.",
  forSale: "A la venta",
  forSaleHelp: "Publica para visualización inmediata.",
  fullDescription: "Descripción completa",
  fullDescriptionPlaceholder: "Registra una descripción completa de tu producto.",
  fullDescriptionPlaceholderService: "Registra una descripción completa de tu servicio.",
  fullDescriptionTip: "Cuida la descripción detallada",
  stock: "Stock",
  stockPlaceholder: "Ej.: 10",
  category: "Categoría",
  subcategory: "Subcategoría",
  selectCategory: "Selecciona una categoría",
  selectSubcategory: "Selecciona una subcategoría",
  selectFileType: "Selecciona un tipo de archivo",
  requiredFieldsHint: "* campos obligatorios para publicar",
  productCharacteristics: "Características del producto",
  productCharacteristicsSubtitle:
    "Organiza la información en grupos. En cada grupo, añade un título y los pares de información que aparecerán en la pestaña de características.",
  serviceCharacteristics: "Características del servicio",
  serviceCharacteristicsSubtitle:
    "Organiza la información en grupos. En cada grupo, añade un título y los pares de información que aparecerán en la pestaña de características del servicio.",
  noCharacteristics: "Ninguna característica registrada.",
  createCharacteristics: "Crear características para mi producto",
  createCharacteristicsService: "Crear características para mi servicio",
  characteristicsFooter: "Este contenido aparecerá en la pestaña de Características del producto.",
  characteristicsFooterService: "Este contenido aparecerá en la pestaña de Características del servicio.",
  addGroup: "Añadir grupo",
  addItem: "Añadir elemento",
  characteristicTitle: "Título",
  characteristicDescription: "Descripción",
  groupNamePlaceholder: "Escribe el nombre del grupo",
  characteristicTitlePlaceholder: "Ej: Material",
  characteristicDescriptionPlaceholder: "Ej: Algodón premium",
  saveCharacteristicGroup: "Guardar",
  removeCharacteristicGroup: "Eliminar grupo",
  characteristicGroupItem: "{count} elemento",
  characteristicGroupItems: "{count} elementos",
  unnamedCharacteristicGroup: "Características",
  priceDetails: "Define los detalles de precio",
  priceDetailsSubtitle: "Cuánto costará el producto, qué descuentos y cashback se aplicarán.",
  priceDetailsSubtitleService:
    "Cuánto costará tu servicio, qué descuentos y cashback se aplicarán.",
  discountAndShippingDetails: "Define descuentos y envío",
  discountAndShippingSubtitle:
    "Tipo de envío, medidas del producto, descuentos y cashback a aplicar.",
  priceHelp: "Define cuánto quieres recibir por el producto.",
  priceHelpService: "Define cuánto quieres recibir por el servicio.",
  discountOptional: "Descuento (Opcional)",
  discountHelp: "Muestra que tu producto está en descuento.",
  discountHelpService: "Muestra que tu servicio está en descuento.",
  cashbackPercent: "Porcentaje de Cashback",
  cashbackHelpPrefix: "Para entender cómo se calcula el precio final, accede a nuestra",
  priceCalculator: "calculadora de precios",
  productDimensions: "Indica las dimensiones de tu producto",
  productDimensionsSubtitle: "Las medidas se usan para calcular el envío.",
  heightCm: "Altura (cm)",
  widthCm: "Ancho (cm)",
  lengthCm: "Largo (cm)",
  weightKg: "Peso (kg)",
  shipping: "Envío",
  shippingHelp: "Cómo prefieres que se gestione el envío de tu producto.",
  shippingSimulator: "Simulador de envío",
  breadcrumbsAriaLabel: "Ruta de navegación",
  freeShipping: "Envío gratis",
  freeShippingDesc: "La tienda es responsable de los costes de envío.",
  paidShipping: "Envío de pago",
  paidShippingDesc: "El cliente paga el envío en el checkout.",
  localPickup: "Recogida en tienda",
  localPickupDesc: "El cliente podrá recoger el pedido en la tienda.",
  productVariations: "Variaciones del producto",
  productVariationsSubtitle:
    "Podrás elegir hasta 2 atributos y hasta 5 variaciones por producto registrado.",
  addVariationOptions: "Añade opciones como color o talla.",
  addAnotherOption: "Añadir otra opción",
  optionName: "Nombre de la opción",
  optionValues: "Valores de la opción",
  addValue: "Añadir valor",
  done: "Hecho",
  variant: "Variante",
  variantPrice: "Precio",
  variantStock: "Stock",
  selectImage: "Seleccionar imagen",
  uploadedImages: "Imágenes cargadas",
  addFiles: "Añadir archivos",
  confirm: "Confirmar",
  addProductImages: "Añadir las imágenes del producto",
  addProductImagesSubtitle:
    "Usa fotos con distintos ángulos para ofrecer una mejor experiencia a tu cliente.",
  addServiceImages: "Añadir las imágenes del servicio",
  addServiceImagesSubtitle:
    "Usa fotos con distintos ángulos para ofrecer una mejor experiencia a tu cliente.",
  uploadFiles: "Cargar archivos",
  uploadZoneFormatsProductImages: "Formatos JPEG, PNG y WEBP. Hasta 5 MB.",
  digitalProductFiles: "Archivos de tu producto digital",
  digitalProductFilesSubtitle: "Sube la portada, el archivo principal y una muestra opcional.",
  coverImage: "Imagen de portada",
  coverImageHelp: "Imagen que aparece en la tienda.",
  coverImageFormats: "Formatos aceptados: JPG, PNG y WebP.",
  coverImageSize: "Tamaño máximo: 3MB.",
  mainProductFile: "Archivo principal del producto",
  mainProductFileHelp: "Archivo que el cliente recibe tras la compra.",
  mainProductFileFormats: "Formatos aceptados: Todos los formatos.",
  mainProductFileSize: "Tamaño máximo: 100MB.",
  previewSample: "Muestra previa (opcional)",
  previewSampleHelp: "Una versión de demostración o reducida del producto.",
  previewSampleFormats: "Formatos aceptados: Todos los formatos.",
  previewSampleSize: "Tamaño máximo: 100MB.",
  selectFiles: "Seleccionar archivos",
  replaceFile: "Cambiar archivo",
  viewFile: "Visualizar",
  uploadedSuccessfully: "Enviado con éxito",
  requiredFilesToPublish: "Los archivos obligatorios deben enviarse para publicar el producto.",
  dragDropOrSelect: "Arrastra y suelta aquí",
  uploadZoneHelp: "o selecciona un archivo de tu ordenador.",
  register: "Registrar",
  noProductsFound: "Ningún producto encontrado.",
  notifyConfirmUsers: "¿Deseas notificar a todos los usuarios sobre este producto?",
  notifyConfirmCircle: "¿Deseas notificar a tu círculo económico sobre este producto?",
  notifyInsufficientBalance: "Saldo de ExtraBonus insuficiente para enviar la notificación.",
  productPublished: "Producto publicado con éxito.",
  productUnpublished: "Producto despublicado con éxito.",
  productNotified: "Notificación enviada con éxito.",
  examplePlaceholder: "Ej.:",
};

export default storeDictES;
